@if (exportLoader) {
<div class="loader text-center">
	<img src="../../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">
		@if (exportLoader) {
		Generating PDF...
		}@else {
		Loading...
		}
	</p>
</div>
}
<div class="container-fluid py-3">
	<div class="card">
		<div class="card-header bg-theme mb-0">
			<h5 class="card-title text-light fw-bold mb-0">
				Roster Scheduler
			</h5>
		</div>
		<div class="card-body p-2">
			<p class="text-muted small mb-2">
				Select employee(s) and drag on the calendar grid to assign time slots.
			</p>
			<div class="row align-items-center mb-3 g-2">
				<div class="col-lg-3 col-md-4">
					<div class="ng-select-default w-100">
						<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name"
							placeholder="Department" [(ngModel)]="filters.department" (change)="onDepartmentChange()"
							appearance="outline" [clearable]="true" [disabled]="disableDepartment" class="w-100">
						</ng-select>
					</div>
				</div>
				<div class="col-lg-5 col-md-4">
					<div class="ng-select-default w-100">
						@if (useMultiSelect) {
						<ng-select [items]="userList" bindValue="emp_code" bindLabel="full_name" [multiple]="true"
							[closeOnSelect]="false" placeholder="Choose employees..."
							[(ngModel)]="filters.selectedEmpCodes" appearance="outline" class="w-100">
							<ng-template ng-option-tmp let-item="item" let-item$="item$">
								<input type="checkbox" [checked]="item$.selected" class="form-check-input me-2" />
								<span class="user-color-dot me-1"
									[style.backgroundColor]="item.color || '#000000'"></span>
								<span>
									{{ item.full_name }}
								</span>
							</ng-template>
						</ng-select>
						}@else {
						<ng-select [items]="userList" bindValue="emp_code" bindLabel="full_name"
							placeholder="Choose employee..." [(ngModel)]="filters.emp_code" appearance="outline"
							class="w-100">
							<ng-template ng-label-tmp let-item="item">
								<span class="user-color-dot me-1" [style.backgroundColor]="item.color || '#000000'">
								</span>
								<span>
									{{ item.full_name }}
								</span>
							</ng-template>
							<ng-template ng-option-tmp let-item="item">
								<span class="user-color-dot me-1" [style.backgroundColor]="item.color || '#000000'">
								</span>
								<span>
									{{ item.full_name }}
								</span>
							</ng-template>
						</ng-select>
						}
					</div>
				</div>
				<div class="col-lg-4 col-md-4">
					<div class="d-flex w-100 gap-2">
						<div class="btn-group flex-grow-1">
							<button class="btn btn-outline-secondary btn-sm w-100" mwlCalendarPreviousView view="week"
								[(viewDate)]="viewDate" [disabled]="events.length">
								<fa-icon [icon]="['fas','long-arrow-alt-left']"></fa-icon>
								Prev
							</button>
							<button class="btn btn-primary btn-sm w-100" mwlCalendarToday [(viewDate)]="viewDate">
								Today
							</button>
							<button class="btn btn-outline-secondary btn-sm w-100" mwlCalendarNextView view="week"
								[(viewDate)]="viewDate" [disabled]="events.length">
								Next
								<fa-icon [icon]="['fas','long-arrow-alt-right']"></fa-icon>
							</button>
						</div>
						<button class="btn btn-success btn-sm flex-grow-1" (click)="submitRoster()"
							matTooltip="Submit Roster">
							@if (submitLoader) {
							<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
							}@else {
							<fa-icon [icon]="['fas', 'save']"></fa-icon>
							}
							Submit
						</button>
					</div>
				</div>
			</div>
			<ng-template #headerTemplate let-days="days">
				<div role="row" class="cal-day-headers">
					@for (day of days; track $index) {
					<div class="cal-header"
						[ngClass]="[day.isPast?'cal-past':'',day.isToday?'bg-primary text-white':'',day.isFuture?'cal-future':'',day.isWeekend?'text-danger':'']">
						<b>{{weekDays[day.day]}}</b>
						<br />
						<label>
							{{months[day.date.getMonth()]}} {{day.date.getDate()}}
						</label>
					</div>
					}
				</div>
			</ng-template>
			<ng-template #hourSegmentTemplate let-segment="segment" let-locale="locale"
				let-segmentHeight="segmentHeight" let-isTimeLabel="isTimeLabel">
				<div class="cal-hour-segment-custom"
					[ngClass]="segment.date.getHours() < 12 ? 'morning-segment' : 'afternoon-segment'"
					[style.height.px]="segmentHeight" (mousedown)="startDragSelect(segment.date)"
					(mouseenter)="updateDragSelect(segment.date)">
					@if (isTimeLabel) {
					<div class="cal-time">
						{{ segment.date | calendarDate:'weekViewHour':locale }}
					</div>
					}
				</div>
			</ng-template>
			<!-- <ng-template #eventTemplateWeek let-weekEvent="weekEvent">
				<div class="cal-event-custom h-100 position-relative d-flex align-items-center justify-content-center"
					[style.backgroundColor]="weekEvent.event.color?.secondary"
					[style.borderLeftColor]="weekEvent.event.color?.primary"
					(mousedown)="startDragSelectOnEvent(weekEvent.event, $event)" [ngbPopover]="popoverContent"
					triggers="mouseenter:mouseleave" container="body" placement="auto">
					<button type="button" class="btn-remove-event" matTooltip="Remove slot"
						(mousedown)="removeEvent(weekEvent.event, $event)">
						&times;
					</button>
					<div class="initial-badge-wrapper">
						<span class="initial-badge" [style.backgroundColor]="weekEvent.event.color?.primary">
							{{ weekEvent.event.meta?.userInitial }}
						</span>
					</div>
					<ng-template #popoverContent>
						<div class="p-1 text-center">
							<div class="fw-bold text-dark mb-1">{{ weekEvent.event.title }}</div>
							<div class="badge bg-light text-dark border">
								{{ weekEvent.event.start | date:'dd-MM-YYYY HH:mm' }}
							</div>
							To
							<div class="badge bg-light text-dark border">
								{{ weekEvent.event.end | date:'dd-MM-YYYY HH:mm' }}
							</div>
						</div>
					</ng-template>
				</div>
			</ng-template> -->
			<ng-template #eventTemplateWeek let-weekEvent="weekEvent">
				<div class="cal-event-custom h-100 position-relative d-flex flex-column align-items-center justify-content-around"
					[style.backgroundColor]="weekEvent.event.color?.secondary"
					[style.borderLeftColor]="weekEvent.event.color?.primary"
					(mousedown)="startDragSelectOnEvent(weekEvent.event, $event)" [ngbPopover]="popoverContent"
					triggers="mouseenter:mouseleave" container="body" placement="auto">
					<button type="button" class="btn-remove-event" matTooltip="Remove slot"
						(mousedown)="removeEvent(weekEvent.event, $event)">
						&times;
					</button>
					@for (item of getRepeatedBadges(weekEvent.event); track $index) {
					<span class="event-text" [class.invisible]="!item.visible"
						[style.color]="weekEvent.event.color?.primary">
						{{ item.text }}
					</span>
					}
					<ng-template #popoverContent>
						<div class="p-1 text-center">
							<div class="fw-bold text-dark mb-1">{{ weekEvent.event.title }}</div>
							<div class="badge bg-light text-dark border">
								{{ weekEvent.event.start | date:'dd-MM-YYYY HH:mm' }}
							</div>
							To
							<div class="badge bg-light text-dark border">
								{{ weekEvent.event.end | date:'dd-MM-YYYY HH:mm' }}
							</div>
						</div>
					</ng-template>
				</div>
			</ng-template>
			<!-- <div class="d-flex justify-content-end mb-2">
				<button id="pdfDownloadBtn" class="btn btn-sm btn-outline-primary" [disabled]="exportLoader"
					(click)="exportToPDF(calendarContainer)" matTooltip="Download PDF">
					<fa-icon [icon]="['fas', 'file-pdf']" class="me-1"></fa-icon>
					Download PDF
				</button>
			</div> -->
			<div #calendarContainer>
				<div class="px-1 mb-2">
					<span class="fw-bold fs-5 text-dark" id="weekViewTitleDoNotRemove">
						{{ viewDate | calendarDate:'weekViewTitle':'en':1 }}
					</span>
				</div>
				@if (showPdfLegend && rosterLegend && rosterLegend.length > 0) {
				<div class="roster-legend-container mb-3 p-2 border rounded bg-light">
					<div class="fw-bold mb-1 text-dark" style="font-size: 12px;">Roster Legend:</div>
					<div class="d-flex flex-wrap gap-2">
						@for (legendItem of rosterLegend; track $index) {
						<div class="d-flex align-items-center gap-1 border rounded px-2 py-1 bg-white shadow-sm"
							style="font-size: 11px;">
							<span
								class="badge rounded-circle d-inline-flex align-items-center justify-content-center text-white"
								[style.background-color]="legendItem.color"
								style="width: 16px; height: 16px; font-size: 9px;">
								{{ legendItem.initials }}
							</span>
							<span class="fw-semibold text-dark">{{ legendItem.name }}</span>
						</div>
						}
					</div>
				</div>
				}
				<mwl-calendar-week-view #calendarWeekViewComponent [viewDate]="viewDate" [events]="events"
					[refresh]="refresh" [weekendDays]="[0]" [weekStartsOn]="1"
					[hourSegmentTemplate]="hourSegmentTemplate" [eventTemplate]="eventTemplateWeek"
					[dayStartHour]="dayStartHour" [dayEndHour]="dayEndHour" [headerTemplate]="headerTemplate"
					[hourSegments]="hourSegmentsWeekView" [hourDuration]="hourDurationWeekView"
					[hourSegmentHeight]="hourSegmentHeightWeekView" [minimumEventHeight]="minimumEventHeightWeekView">
				</mwl-calendar-week-view>
			</div>
		</div>
	</div>
</div>